var Component = require("!../../../../../../../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ChildrenAvatarStub.vue"),
  /* template */
  require("!!../../../../../../../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5d889529\",\"hasScoped\":false,\"preserveWhitespace\":false}!../../../../../../../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ChildrenAvatarStub.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/avatar/components/stub/ChildrenAvatarStub.vue
// module id = 9d18a61f0cb9d87519c8
// module chunks = 89